import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IGroupEmail } from "../../utils/types/models";

export default createEntityReducer<IGroupEmail>(Endpoint.GroupEmails, Endpoint.GroupEmailsList);
